import Layout, { Footer } from "antd/lib/layout/layout";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//Internal Imports
import "../HistoricoEntidadEncuestada.css"
import LogoBis from "../../../../common/components/LogoBis/LogoBis";
import MenuHeader from "../../../../common/components/MenuHeader/MenuHeader";
import SearchText from "../../../../common/components/SearchText/SearchText";
import { COLORS } from "../../../../common/constants/colors";
import { useForm } from "../../../../contexts/form";
import { IEntitySurveided } from "../../../../interfaces/IEntitySurveided";
import { GetFormsHistoricByFormID } from "../../../../services/survey";
import { openNotification, tryCatch } from "../../../../common/constants/Utilities";
import LoadingPage from "../../../../common/components/LoadingPage/LoadingPage";
import LabelNotFound from "../../../../common/components/Label/LabelNotFound";
import EntidadEncuestadaItem from "../../../../common/components/EntidadEncuestadaItem/EntidadEncuestadaItem";
import { useListUsers } from "../../../../hooks/useListUsers";



const HistoricoEntidadUsuario = () => {
    const [searchV, setSearchV] = useState<string>('');
    const [listEntitySurveided, setListEntitySurveided] = useState<IEntitySurveided[]>([]);
    const { answerEntitySelected, setAnswerEntitySelected } = useForm();
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const { listUserAll, loadingUserAll } = useListUsers();

    //method
    const getListEntitySurveidedFiltered = useCallback(
        () => {
            let entitySurveidedFiltered: IEntitySurveided[] = [];
            const valueLowerCase = searchV.toLocaleLowerCase();
            let valueLowerCaseSplit = valueLowerCase.split("/");
            let dateValue = valueLowerCaseSplit.reverse().join("-");
            if (!!valueLowerCase) { 
                entitySurveidedFiltered = listEntitySurveided.filter((list) => list.nombre?.toLocaleLowerCase().includes(valueLowerCase) || list.codigo?.toLocaleLowerCase().includes(valueLowerCase) || list.fechaModificacion?.toLocaleLowerCase().includes(dateValue) || list.nombreUsuario?.toLocaleLowerCase().includes(valueLowerCase))
            } else {
                entitySurveidedFiltered = listEntitySurveided
            }
            return entitySurveidedFiltered;

        }, [searchV, listEntitySurveided])

    const gotoAnswers = (AnswerId: number) => {
        setAnswerEntitySelected({ ...answerEntitySelected, answerId: AnswerId, fechaDesde: undefined, fechaHasta: undefined });
        navigate(`/RespuestaFormulario`);
    }

    useEffect(() => {
        tryCatch(() => {
            if (!loadingUserAll)
            {
                setFormLoading(true);
                GetFormsHistoricByFormID(answerEntitySelected?.formId!).then(response => {
                    const listResponse: IEntitySurveided[] = response.data;
                    listResponse.forEach(qtSurvey => {
                        qtSurvey.nombreUsuario = listUserAll.find(user => user.usuarioGUID === qtSurvey.usuarioCreadorGUID)?.nombreUsuario;
                    }) 
                    setListEntitySurveided(listResponse);
                    
                })
                .catch((response) => {
                    openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                })
                .finally(() => setFormLoading(false));
            }            
        })        
    }, [loadingUserAll]);

    return (
        <div >
            <div className={"nav_header"}>
                <LogoBis />
                <MenuHeader currentPage={answerEntitySelected?.formName!} isMenu={false} />
            </div>
            <div className={"entitySurveided_container"}>
                <SearchText
                    value={searchV}
                    active={true}
                    borderColor={COLORS.black_back_color5}
                    textColor={COLORS.black_text_color1}
                    placeholdercolor={COLORS.black_text_color4}
                    name={"search_table"}
                    onChange={setSearchV}
                    placeholder={"Buscar"}
                    backgroundcolor={COLORS.black_back_color5}
                    opacity={1}
                    props={{ collapsed: 'false' }}
                />
                <div className="historic-Entity-container-data">
                    <div>
                        {formLoading.toString() === 'true'
                            ? <div className="loading-container"> <LoadingPage message="Cargando..." /></div>
                            : getListEntitySurveidedFiltered()?.length === 0 ? <div className="loading-container"> <LabelNotFound message="No se encontró la busqueda." /></div>
                                :
                                getListEntitySurveidedFiltered().map((entitySurvey: IEntitySurveided) =>
                                    <EntidadEncuestadaItem key={entitySurvey.respuestaID} formularioID={entitySurvey.formularioID} respuestaID={entitySurvey.respuestaID} formularioListadoDetalleID={entitySurvey.formularioListadoDetalleID} fecha={entitySurvey.fechaModificacion} hora={entitySurvey.fechaModificacion} codigo={entitySurvey.codigo} nombre={entitySurvey.nombre} usuarioCreadorGUID={entitySurvey.nombreUsuario} active={true} method={() => gotoAnswers(entitySurvey.respuestaID)} textColor={COLORS.blue_active} />
                                )

                        }
                    </div>

                </div>
            </div>
            <Layout>
                <Footer className={"entitySurveided_footer"}>
                    <div className={"footer-column-2"}>
                        <h3>{answerEntitySelected?.listadoNombre!}</h3>
                        <h2>{getListEntitySurveidedFiltered().length}</h2>
                    </div>
                </Footer>
            </Layout>
        </div>
    )
}

export default HistoricoEntidadUsuario;